import IconDotted from "@/assets/svgs/icon-dotted.svg";
import { ReactComponent as IconEllipse } from "@/assets/svgs/icon-ellipse.svg";
import { ReactComponent as IconChevron } from '@/assets/svgs/profile-chevron.svg';
import Popover from '@/components/Popover/index';
import useDid from '@/hooks/use-did/index';
import { useEffect, useRef, useState } from 'react';
import WalletDropdown from '../wallet-dropdown/index';
import PropTypes from 'prop-types';

const UpdateWallet = ({
	title,
	currentWallet,
	addressBook,
	fetchEtr,
	addToastMessage,
	selectedWallet,
	setSelectedWallet,
	isSelectable,
	nominatedBeneficiary,
	isEditRequest
}) => {
	const { toFindOrgName } = useDid()

	const orgName = toFindOrgName(currentWallet) || addressBook.find((item) => item.walletAddress === currentWallet)?.orgName

	const [filterVisible, setFilterVisible] = useState(false)
	const referenceRef = useRef(null)

	/*=================================================
		Popover
	/================================================*/

	useEffect(() => {
		document.addEventListener('mousedown', handleDocumentClick)
		return () => {
			document.removeEventListener('mousedown', handleDocumentClick)
		}
	}, [])

	function handleDocumentClick(event) {
		if (!referenceRef.current) {
			return
		}

		if (referenceRef.current.contains(event.target)) {
			return
		}

		setFilterVisible(false)
	}

	return (
		<>
			<div className={(isSelectable && isEditRequest) ? "etr-maker-checker__update-wallet" : "etr__update-wallet"}>
				<div className="etr__update-wallet__title">
					{title}
				</div>
				{isSelectable && (
					<div className="etr__update-wallet__content">
						<div className="etr__update-wallet__section etr__update-wallet__top">
							<div className="etr__update-wallet__left">
								<IconEllipse />
								<div className="etr__update-wallet__line"
									style={{ backgroundImage: `url(${IconDotted})` }}
								>
								</div>
							</div>
							<div className="etr__update-wallet__right">
								<div className="etr__update-wallet__upper etr__update-wallet__text">
									{orgName} <span className='etr__update-wallet__text--subtitle'>(Your Address)</span>
								</div>
								<div className="etr__update-wallet__text--subtitle">
									{currentWallet}
								</div>
							</div>
						</div>
						<div className="etr__update-wallet__section etr__update-wallet__bottom">
							<div className="etr__update-wallet__left etr__update-wallet__left--active">
								<IconEllipse />
							</div>
							<div className="etr__update-wallet__right">
								<div className="etr__update-wallet__upper etr__update-wallet__title">
									<span className="required-message">*</span>New {title}
								</div>
								<Popover visible={filterVisible}
									options={{ modifiers: [{ name: 'offset', options: { offset: [0, 10] } }] }}
									display='block'
									placement='bottom-end'
								>
									<Popover.Trigger>
										<div className="etr__update-wallet__dropdown dropdown" >
											<div className="dropdown__select" onClick={() => { setFilterVisible(true) }}>
												<span className='dropdown__placeholder'>
													{(selectedWallet === null || selectedWallet?.id === "custom") && (
														<span>Select New {title}</span>
													)}
													{!(selectedWallet === null || selectedWallet?.id === "custom") && (
														<span>{`${selectedWallet?.name} - ${selectedWallet?.walletAddress}${selectedWallet?.email ? " - " + selectedWallet?.email : ""}`}</span>
													)}
												</span>
												<div className="dropdown__select__icon">
													<IconChevron />
												</div>
											</div>
										</div>
									</Popover.Trigger>
									<Popover.Content>
										<WalletDropdown
											addressBook={addressBook}
											referenceRef={referenceRef}
											fetchEtr={fetchEtr}
											addToastMessage={addToastMessage}
											setSelected={setSelectedWallet}
											selected={selectedWallet}
											nominatedBeneficiary={nominatedBeneficiary}
											title={title}
										/>
									</Popover.Content>
								</Popover>
								{(title === 'Owner' && nominatedBeneficiary) && (
									<div className="etr__update-wallet__subtitle__warning">
										{`There is a pending nomination to ${nominatedBeneficiary}.`}
									</div>
								)}
							</div>
						</div>
					</div>
				)}
				{!isSelectable && (
					<div className="etr__update-wallet__content">
						<div className="etr__update-wallet__section etr__update-wallet__top">
							<div className="etr__update-wallet__right etr__update-wallet__right--no-margin">
								<div className="etr__update-wallet__upper etr__update-wallet__text">
									{orgName}
								</div>
								<div className="etr__update-wallet__text--subtitle">
									{currentWallet}
								</div>
							</div>
						</div>
					</div>
				)}
			</div>
		</>
	)
}

UpdateWallet.defaultProps = {
	title: PropTypes.string,
	currentWallet: PropTypes.string,
	addressBook: [],
	fetchEtr: PropTypes.func,
	addToastMessage: PropTypes.func,
	selectedWallet: null,
	setSelectedWallet: PropTypes.func,
	isSelectable: PropTypes.bool,
	nominatedBeneficiary: null,
	isEditRequest: PropTypes.bool
}

export default UpdateWallet;
